export default {"src":"/_next/static/media/Check-3.f36c9aeb.svg","height":24,"width":24};